export default "/images/vtb_bank.png?9e1754aae288e41b0e6623d1efcecbbb";